import PropTypes from 'prop-types';

import { StyledCardItem } from '#client/pages/EducationStudio/components/Interactive/BubbleSelectionActivity/cardItem';
import {
  HeaderWithBottomGap
} from '#client/pages/EducationStudio/components/Interactive/BubbleSelectionActivity/styled.components';
import superstyled from '#client/pages/EducationStudio/utils/superstyled';

import { CardHeader } from './cardHeader';

export const CardHeaderWithGap = superstyled({
  tag: CardHeader,
  styles: {
    marginBottom: '0.5rem'
  }
});
export const SelectionCard = ({ user, items }) => {
  const totalCardItems = items.length;
  const cardItems = items.map(({ text, bgColor }, index) => {
    const isLastItem = totalCardItems - 1 === index;

    return (
      <StyledCardItem
        key={text}
        text={text}
        bgColor={bgColor}
        isLastItem={isLastItem}
      />
    );
  });

  return (
    <HeaderWithBottomGap>
      <CardHeaderWithGap user={user} />
      {cardItems}
    </HeaderWithBottomGap>
  );
};

SelectionCard.propTypes = {
  user: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    bgColor: PropTypes.string
  }))
};

SelectionCard.defaultProps = {
  user: 'User',
  items: []
};
